import { DEFAULT_CONTROL_VALUES } from "./constants";

export const clampValue = (value, min, max) => Math.min(Math.max(value, min), max);

export const resolveHeatAndCoolSetpoints = (heatF, coolF, coolMinF, heatMaxF) => {
  if (heatF == null || coolF == null) {
    return { heatF, coolF };
  }
  if (coolF - heatF >= DEFAULT_CONTROL_VALUES.DEAD_BAND_F) {
    return { heatF, coolF };
  }
  if (heatF > coolF) {
    return {
      heatF,
      coolF: clampValue(
        heatF + DEFAULT_CONTROL_VALUES.DEAD_BAND_F,
        coolMinF,
        DEFAULT_CONTROL_VALUES.COOL_UPPER_LIMIT_F
      ),
    };
  }
  return {
    heatF: clampValue(
      coolF - DEFAULT_CONTROL_VALUES.DEAD_BAND_F,
      DEFAULT_CONTROL_VALUES.HEAT_LOWER_LIMIT_F,
      heatMaxF
    ),
    coolF,
  };
};

export const resolveDisplaySetpoints = (selectedMode, heatF, coolF, coolMinF, heatMaxF) => {
  const isSingleSetpointMode =
    selectedMode === "HEAT" || selectedMode === "COOL" || selectedMode === "DRY";
  if (isSingleSetpointMode) {
    return { heatF, coolF };
  }
  return resolveHeatAndCoolSetpoints(heatF, coolF, coolMinF, heatMaxF);
};
